import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { reducer as formReducer } from "redux-form";
import appraiser from "./appraiser";
import assignment from "./assignment";
import { broker, brokerMaintenanceSettings } from "./broker";
import caseDetails from "./homeowner/casedetails";
import caseForms from "./homeowner/caseforms";
import caseTimeLog from "./caseTimeLog";
import changeStatus from "./changeStatus";
import comparable from "./comparable";
import dashboard from "./homeowner/dashboard";
import layout from "./layout";
import persist from "./persist";
import search from "./search";
import snackbar from "./snackbar";
import { user, brokerRegistration, twoFactor } from './user';
import validation from "./validation";
import webOrder from "./webOrder";
import appraiserManagerAssignRegion from "./appraiserSupport";
import preferences from "./preferences";
import filters from "./filters";
import fieldRep from "./fieldRep";
import qualityAssurance from "./qualityAssurance";
import roleRights from "./user/rolerights";
import quickList from "./homeowner/quickList";
import caseAlerts from "./CaseAlerts";
import homeownerCustomer from "./homeowner/customer";
import customerService from "./customerService";
import customer from "./customer";
import fieldLevelCoordinators from "./fieldLevelCoordinators";
import region from "./region";
import employee from "./employee";
import caseStepper from "./caseStepper";
import appraisalPort from "./appraisalPort";
import caseLinks from "./caseLinks";
import riskProfiler from "./collateralAnalytics";
import exportTypes from "./exportTypes";
import schedulingAssistant from './callCenter';
import exports from './exports';
import underwriter from './underwriter';
import caseAppointment from "./caseAppointment";

// How to reset store
// Suggested by Dan
//https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store
const appReducer = combineReducers({
  routing: routerReducer,
  form: formReducer,
  appraisalPort,
  appraiser,
  appraiserManagerAssignRegion,
  assignment,
  broker,
  brokerRegistration,
  brokerMaintenanceSettings,
  caseAlerts,
  caseDetails,
  caseForms,
  caseLinks,
  caseStepper,
  caseTimeLog,
  changeStatus,
  comparable,
  customer,
  customerService,
  dashboard,
  employee,
  exportTypes,  
  fieldLevelCoordinators,
  filters,
  fieldRep,
  homeownerCustomer,
  layout,
  persist,
  preferences,
  qualityAssurance,
  quickList,
  region,
  riskProfiler,
  roleRights,
  search,
  snackbar,
  twoFactor,
  underwriter,
  user,
  validation,
  webOrder,
  schedulingAssistant,
  exports,
  caseAppointment,
});

const rootReducer = (state, action) => {
  if (action.type === "REQUEST_USER_LOGOUT") {
    const { routing } = state;
    state = { routing };
  }
  return appReducer(state, action);
};

export { appReducer };
export default rootReducer;
